import React from 'lib/react';
import PropTypes from 'prop-types';
import PaymentInformationStyles from './PaymentSectionStyles';

function PaymentSectionFooter(props) {
  const {
    paymentOption, planType, subText, boldText, billingMaster,
  } = props;
  const classes = PaymentInformationStyles();
  return (
    <>
      <div className={classes.paymentOption}>
        {paymentOption}
      </div>
      {planType && (
        <div className={classes.planType}>
          {planType}
        </div>
      )}
      <div>
        {subText}
      </div>
      <div className={classes.accountBalance}>
        {boldText}
      </div>
      <div>
        {billingMaster}
      </div>
    </>
  );
}
PaymentSectionFooter.propTypes = {
  paymentOption: PropTypes.string,
  planType: PropTypes.string,
  subText: PropTypes.string,
  boldText: PropTypes.string,
  billingMaster: PropTypes.string,
};

PaymentSectionFooter.defaultProps = {
  paymentOption: '',
  planType: '',
  subText: '',
  boldText: '',
  billingMaster: '',
};
export default PaymentSectionFooter;
